import image1 from "../../assets/IMG.png";

const slides = [
    {
      title: "3 Days strenth workout",
      date: "12 August 2023",
      image: image1,
    },
    {
      title: "3 Days strenth workout",
      date: "12 August 2023",
      image: image1,
    },
  ];
  
export const getNews = () => {
    return slides;
};
